import { StringHelper } from "../../../Helpers/StringHelper";
import { IInputControl } from "../InputControl";
import { NAMESPACE } from "./_Namespace";

export interface ICopyValueToClipboardMixin extends IInputControl
{
    copyValueToClipboardAsync(): Promise<void>;
}

export class CopyValueToClipboardMixin
{
    public static classNamespace = NAMESPACE + "CopyValueToClipboardMixin";
    public static className = "CopyValueToClipboardMixin";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    public static copyValueToClipboardAsync(control: ICopyValueToClipboardMixin): Promise<void>
    {
        if (navigator.clipboard)
            return navigator.clipboard.writeText(`${control.value.get()}`);

        const
            textArea = document.createElement("textarea");

        textArea.value = control.value.get();
        textArea.setAttribute("readonly", StringHelper.empty);
        textArea.style.position = "absolute";
        textArea.style.left = "-9999px";
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        return Promise.resolve();
    }
}